import Tool from '../tool';
import * as constants from '../../constants';
import AnswerButton from './answer-button';

const dotColour = constants.lightBlueGrey;
const dotRadius = 8;
const dotSpacing = 7;
const dotAndSpace = 2 * dotRadius + dotSpacing;

const sprite = new PIXI.Sprite();
const topText = new PIXI.Text('', { font: '18px Open Sans, Arial', fill: 0xFFFFFF });
const arrayContainer = new PIXI.Sprite();
const bottomText = new PIXI.Text('', { font: '18px Open Sans, Arial', fill: 0xFFFFFF });

const arrayContainerTop = 45;
const arrayContainerHeight = 12 * dotAndSpace - dotSpacing;
const arrayContainerMidY = arrayContainerTop + 0.5 * arrayContainerHeight;

topText.y = 10;
bottomText.y = 330;
AnswerButton.container.y = 380;

[ topText, bottomText, AnswerButton.container ].forEach(s => {
  sprite.addChild(s);
  s.anchor.set(0.5, 0);
  s.x = constants.screenCentreX;
});
sprite.addChild(arrayContainer);
arrayContainer.anchor.set(0.5);
arrayContainer.position.set(constants.screenCentreX, arrayContainerMidY);

for ( let i = 0; i < 4; i++ ) {
  new AnswerButton();
}

export default class MultiChoiceArrayTool extends Tool {
  static init() {
    this._sprite = sprite;
  }

  static loadQuestion( question ) {
    super.loadQuestion(question);

    topText.text = question.title[ 0 ];
    bottomText.text = question.title[ 1 ];

    AnswerButton.loadQuestion(question);

    arrayContainer.removeChildren();

    const xOffset = -0.5 * ( question.multiplier - 1 ) * dotAndSpace;
    const yOffset = -0.5 * ( question.multiplicand - 1 ) * dotAndSpace;

    for ( let i = 0; i < question.multiplier; i++ ) {
      const x = xOffset + i * dotAndSpace;

      for ( let j = 0; j < question.multiplicand; j++ ) {
        const y = yOffset + j * dotAndSpace;

        const g = new PIXI.Graphics();
        g.position.set(x, y);

        g.beginFill(dotColour).drawCircle(0, 0, dotRadius).endFill();
        arrayContainer.addChild(g);
      }
    }
  }

  static onQuestionComplete( question ) {
    AnswerButton.onQuestionComplete(question);
  }
}
